import Api from 'api';
import {
  ADD_ROLE,
  GET_ROLES,
  GET_ROLE_BY_ID,
  MODIFY_ROLE,
  SET_EDITING_ROLE,
  SET_ROLES_FILTERS,
  SET_ROLES_PAGINATION,
  TOGGLE_ROLE,
  UPDATE_ROLE,
} from 'roles/constants';

export const getRoles = (companyId, filters, limit, page, orderBy, order) => ({
  type: GET_ROLES,
  meta: { needAuth: true },
  payload: Api.roles.getRoles(companyId, filters, limit, page, orderBy, order),
});

export const addRole = (companyId, data) => ({
  type: ADD_ROLE,
  meta: { needAuth: true },
  payload: Api.roles.addRole(companyId, data),
});

export const updateRole = (companyId, roleId, data) => ({
  type: UPDATE_ROLE,
  meta: { needAuth: true },
  payload: Api.roles.updateRole(companyId, roleId, data),
});

export const toggleRole = (companyId, roleId, data) => ({
  type: TOGGLE_ROLE,
  meta: { needAuth: true, id: roleId },
  payload: Api.roles.toggleRole(companyId, roleId, data),
});

export const modifyRole = (data) => ({
  type: MODIFY_ROLE,
  payload: data,
});

export const setEditingRole = () => ({
  type: SET_EDITING_ROLE,
});

export const getRoleById = (companyId, roleId) => ({
  type: GET_ROLE_BY_ID,
  meta: { needAuth: true },
  payload: Api.roles.getRoleById(companyId, roleId),
});

export const setFilters = (data) => ({
  type: SET_ROLES_FILTERS,
  payload: data,
});

export const setPagination = (data) => ({
  type: SET_ROLES_PAGINATION,
  payload: data,
});

export const getRolesList = () => ({
  type: TOGGLE_ROLE,
  meta: { needAuth: true },
});



// WEBPACK FOOTER //
// src/modules/secured/modules/roles/actions/roles_actions.js